import {
    FlightAirspaceCrossing,
    FlightDto,
    FlightDynamicVolumeCrossing,
    FlightModelType,
    FlightPointDto,
    TimePeriod,
} from 'app/model/CORE';
import { Point3d } from 'app/model/client/CORE';
import { PathPointLoadClassification } from 'app/unity/ContentViewerTypes/PathPointLoadClassification';

export interface FlightMapOptions {
    showIfpzPartOfTrajectoryOnly: boolean;
    autoZoom: boolean;
    centerOnSelectedTvs?: boolean;
    listVectorPoints: boolean;
    showActiveAirspaceOnly: boolean;
    showElementaryAirspaceOnly: boolean;
    //showAllFlightsModels : boolean;

    //innove specific
    showActiveDynamicVolumeOnly: boolean;
    showActiveDynamicVolumeInVpd: boolean;
}

export interface FlightTrajectory {
    modelType: FlightModelType;
    subject: string;
    majorIndex: number;
    points: Point3d[];
}

export class FlightAndModelType {
    flight: FlightDto;
    modelType: FlightModelType;

    constructor(flight: FlightDto, modelType: FlightModelType) {
        this.flight = flight;
        this.modelType = modelType;
    }

    getPoints = (): Array<FlightPointDto> => {
        switch (this.modelType) {
            case FlightModelType.FTFM:
                return this.flight.ftfmPoints;
            case FlightModelType.RTFM:
                return this.flight.rtfmPoints;
            case FlightModelType.CTFM:
                return this.flight.ctfmPoints;
        }
    };

    getAirspacePoints = (): Array<FlightAirspaceCrossing> => {
        switch (this.modelType) {
            case FlightModelType.FTFM:
                return this.flight.ftfmAirspacePoints;
            case FlightModelType.RTFM:
                return this.flight.rtfmAirspacePoints;
            case FlightModelType.CTFM:
                return this.flight.ctfmAirspacePoints;
        }
    };

    getDynamicVolumes = (): Array<FlightDynamicVolumeCrossing> => {
        switch (this.modelType) {
            case FlightModelType.FTFM:
                return this.flight.ftfmDynamicVolumeProfile;
            case FlightModelType.RTFM:
                return this.flight.rtfmDynamicVolumeProfile;
            case FlightModelType.CTFM:
                return this.flight.ctfmDynamicVolumeProfile;
        }
    };
}

export interface MapFlightPointPojo {
    id: string;
    label: string;
    point: Point3d;
    subject: string;
    majorIdx: number;
    modelType: FlightModelType;
    minorIdx: number;
    strokeStyle: string;
}

export interface ProfileSegmentHighlight {
    timePeriod: TimePeriod;
    // loadClassification: FlightPathPointLoadClassification;
    loadClassification: PathPointLoadClassification;
}

// NOTE(bjarne): For backwards compatibility with iFlow in case we need it
export const getFillColour = (classification: PathPointLoadClassification) => {
    switch (classification) {
        case PathPointLoadClassification.OVERLOAD:
            return '#FF0000';
        case PathPointLoadClassification.HIGH:
            return '#CC9933';
        case PathPointLoadClassification.LOW:
            return '#726648';
    }
};
